/**
 * Represents a FskFormElement container element for e.g. input, textarea, select
 * all elements templates and stylings are defined by FSK
 * this is only to enhance these container elements with functionality
 */
class FskFormElement {
  /**
   * @param {HTMLElement} element - FskFormElement
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        description: ".FskFormElement-description",
        input: ".FskInput",
        remainingSymbols: ".js-FskInput-remainingSymbols",
      },
      classes: {
        hidden: "is-hidden",
      },
    };

    this.description = this.element.querySelector(
      this.config.selectors.description
    );
    this.input = this.element.querySelector(this.config.selectors.input);

    this.remainingSymbols = this.element.querySelector(
      this.config.selectors.remainingSymbols
    );

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    if (
      this.input &&
      this.input.type === "date" &&
      this.input.hasAttribute("data-min")
    ) {
      this._addMinDateAttribute();
    }

    if (this.input && this.description) {
      this._toggleDescriptionVisibility({ hide: true });
    }

    this._bind();
  }

  /**
   * toggles visibility of description
   *
   * @param {object} options
   * @private
   */
  _toggleDescriptionVisibility(options) {
    this.description.classList.toggle(this.config.classes.hidden, options.hide);
  }

  /**
   * binds event listener
   *
   * @private
   */
  _bind() {
    if (this.input && this.description) {
      this.input.addEventListener("focus", () => {
        this._onFocus({ hide: false });
      });
      this.input.addEventListener("blur", () => {
        this._onFocus({ hide: true });
      });
    }

    if (
      this.input &&
      this.input.hasAttribute("maxlength") &&
      this.remainingSymbols
    ) {
      this.input.addEventListener("keyup", (event) => {
        this._remainingSymbolsCount(event);
      });
    }
  }

  /**
   * handles focus of input element
   *
   * @param {object} options
   * @private
   */
  _onFocus(options) {
    this._toggleDescriptionVisibility(options);
  }

  /**
   * count the remaining symbols
   *
   *@param {event} event
   * @private
   */
  _remainingSymbolsCount(event) {
    const maxLength = event.target.getAttribute("maxlength");
    const currentLength = event.target.value.length;

    this.remainingSymbols.innerHTML = maxLength - currentLength;
  }

  /**
   * add `min` attr to the date input
   *
   * @private
   */
  _addMinDateAttribute() {
    const currentDate = new Date();
    const numberOfAdditionalDays = Number(this.input.getAttribute("data-min"));
    const resultDate = new Date(
      currentDate.setDate(currentDate.getDate() + numberOfAdditionalDays)
    );
    this.input.setAttribute("min", resultDate.toISOString().split("T")[0]);
  }
}

export default FskFormElement;
